import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IMerchant, IPixKey } from 'src/app/domain/registration/models/merchants/IMerchant';
import { MerchantService } from 'src/app/views/registration/merchants/crud-service';
import { ToastService } from 'src/app/shared/services/toast/toast.service';

export interface ChargePixKeySelectData {
    merchant: IMerchant;
    mode?: 'view' | 'select';
}

@Component({
    selector: 'app-charge-pix-key-select',
    templateUrl: './charge-pix-key-select.component.html',
    styleUrls: ['./charge-pix-key-select.component.sass']
})
export class ChargePixKeySelectComponent {
    loadingKeyId: string | null = null;

    constructor(
        private dialogRef: MatDialogRef<ChargePixKeySelectComponent>,
        private merchantService: MerchantService,
        private toastService: ToastService,
        @Inject(MAT_DIALOG_DATA) public data: ChargePixKeySelectData
    ) {}

    get isSelectMode(): boolean {
        return this.data.mode === 'select';
    }

    onSetDefault(key: IPixKey): void {
        if (this.loadingKeyId || key.isDefault) return;

        this.loadingKeyId = key.id;
        this.merchantService.setDefaultPixKey(key.id).subscribe({
            next: () => {
                this.loadingKeyId = null;
                this.toastService.showSuccess('Chave PIX padrão atualizada com sucesso!');
                this.dialogRef.close({ updated: true });
            },
            error: (err: any) => {
                this.loadingKeyId = null;
                const msg = err?.error?.message || err?.message || 'Erro ao atualizar chave PIX padrão';
                this.toastService.showError(msg);
            }
        });
    }

    onClose(): void {
        this.dialogRef.close();
    }

    getTypeIcon(keyType: string | null): string {
        if (!keyType) return 'key';
        const icons: Record<string, string> = {
            PHONE: 'phone',
            CPF: 'person',
            CNPJ: 'business',
            EMAIL: 'email',
            RANDOM: 'vpn_key'
        };
        return icons[keyType] ?? 'key';
    }

    getTypeLabel(keyType: string | null): string {
        if (!keyType) return 'Desconhecido';
        const labels: Record<string, string> = {
            PHONE: 'Telefone',
            CPF: 'CPF',
            CNPJ: 'CNPJ',
            EMAIL: 'E-mail',
            RANDOM: 'Aleatória'
        };
        return labels[keyType] ?? keyType;
    }
}
